export const GET_LETTER_HISTORY = 'GET_LETTER_HISTORY'
